import { createSlice } from '@reduxjs/toolkit';
// import type { PayloadAction } from '@reduxjs/toolkit';

export interface AyudantiaState {
    id: string
    cid: string
    mid: string
    numero: number
    enunciado: string
    solucion: string
}

export interface AyudantiasState {
    ayudantia: AyudantiaState
    ayudantias: Array<AyudantiaState>
    isLoading: boolean
}

const initialState: AyudantiasState = {
    ayudantia: {id: '', cid: '', mid: '', numero: 0, enunciado: '', solucion: ''},
    ayudantias: [], 
    isLoading: false

}

export const ayudantiaSlice = createSlice({
    name: 'ayudantias',
    initialState,
    reducers: {
        setAyudantia: (state, action) => {
            state.ayudantia = action.payload
        },
        setAyudantias: (state, action) => {
            state.ayudantias = action.payload
        },
        startLoadingAyudantia: (state) => {
            state.isLoading = true;
        },
        endLoadingAyudantia: (state) => {
            state.isLoading = false;
        },
    },
})

// Action creators are generated for each case reducer function
export const { 
    setAyudantia,
    setAyudantias,
    startLoadingAyudantia, 
    endLoadingAyudantia 
} = ayudantiaSlice.actions

